<h1 style="text-align: center;">Business Wise Discount For Milk and Fermented Products</h1>
<table class="table table-dark">
  <thead>
    <tr>
      <th scope="col">
        <input matInput type="text" #filter
        style="border: 2px solid lightgray;border-radius: 10px;margin-top: 10px;text-indent: 10px;width: 75%;color: white;">
      </th>
      <th *ngFor="let product of discount_products" scope="col">{{product['short_name']}}</th>
    </tr>
    <tr>
      <th scope="col">MRP</th>
      <th *ngFor="let product of discount_products" scope="col">{{product['mrp'] | currency:'INR'}}</th>
    </tr>
    <tr>
        <th scope="col">GST</th>
        <th *ngFor="let product of discount_products" scope="col">{{product['gst']}} %</th>
      </tr>
  </thead>
  <tbody>
    <tr *ngFor="let business of discount_business | globalSearch:'name': filter.value">
      <th scope="row">{{business['name']}}</th>
      <td *ngFor="let product of discount_products" style="cursor: pointer;"
        (click)="openDialog(business['id'], business['name'], product['id'], product['short_name'], discountPrice(business['id'], product['id']))">
        {{discountPrice(business['id'], product['id'])}}</td>
    </tr>
  </tbody>
</table>
